module.exports = __webpack_public_path__ + "static/media/baignade.14929ada.png";